export default "__VITE_ASSET__e84caad7__"